/**
 * Единый путь конверсии сайта — ранний доступ к WEBDAD OS.
 *
 * Сейчас WEBDAD не продаёт проекты, а набирает первых пользователей: людей,
 * которые сами видят, что хотят автоматизировать, и готовы влиять на продукт.
 * Поэтому на всём сайте одна кнопка с одной подписью и одна форма, а контекст
 * страницы меняет только заголовок и одну-две строки под ним. Слова
 * «заказать», «оставить заявку», «обсудить проект» здесь не используются
 * намеренно: блок должен звучать как приглашение в круг первых пользователей,
 * а не как бриф агентства.
 *
 * Правило размещения: на длинных страницах блок стоит дважды (в середине и в
 * конце), на коротких — один раз в конце. Других CTA-блоков на странице нет.
 */
export const EARLY_ACCESS_LABEL = "Стать ранним пользователем"

/** Мелкий текст под кнопкой: отсекает тех, у кого ещё нет задачи. */
export const EARLY_ACCESS_NOTE =
  "Для тех, кто уже представляет, что хотел бы автоматизировать или изменить в своей компании."

export type EarlyAccessCopy = {
  title: string
  lead: string
  note?: string
}

/** Тексты для типовых страниц. Продуктовые страницы передают свои. */
export const earlyAccessCopy = {
  home: {
    title: "Постройте свою компанию на новой операционной системе",
    lead: "Ищем предпринимателей и команды, которые любят экспериментировать, автоматизировать и пробовать новые способы управления бизнесом.",
  },
  // ⁠ (word joiner) после дефиса не даёт строке порваться на «AI-» / «чат».
  models: {
    title: "Не ещё один AI-⁠чат. Операционная система для бизнеса",
    lead: "WEBDAD OS связывает ваши проекты, процессы, данные и AI-⁠модели в одну систему, которая знает контекст компании и помогает вести работу постоянно. Ищем предпринимателей, которые хотят первыми построить её вокруг своего бизнеса.",
    note: "Можно использовать Claude, GPT и другие модели. WEBDAD OS не заменяет их, а объединяет вокруг вашего бизнеса.",
  },
  os: {
    title: "Соберите WEBDAD OS в своей компании одними из первых",
    lead: "Подключаем модули по одному, начиная с процесса, который сейчас отнимает больше всего времени. Что появится следующим, во многом решают ранние пользователи.",
  },
  case: {
    title: "Попробуйте такой подход у себя",
    lead: "Решения из наших проектов теперь собираются в WEBDAD OS. Ищем компании, которые первыми подключат их к своей работе и помогут сделать систему лучше.",
  },
  article: {
    title: "Проверьте эту идею на своей компании",
    lead: "То, о чём мы пишем, собирается в WEBDAD OS. Ищем предпринимателей, которые хотят первыми применить это к своим процессам.",
  },
  store: {
    title: "Не нашли нужное приложение?",
    lead: "Опишите задачу, которую хотите решить. Ранние пользователи WEBDAD OS получают приложения в своём контуре и влияют на то, что появится в Store следующим.",
  },
} satisfies Record<string, EarlyAccessCopy>

export type EarlyAccessPreset = keyof typeof earlyAccessCopy
